import { render, staticRenderFns } from "./SearchProductTable.vue?vue&type=template&id=3cc44aa1&"
import script from "./SearchProductTable.vue?vue&type=script&lang=js&"
export * from "./SearchProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports